import React, { Component } from 'react'
import { connect } from 'react-redux'
import {createStructuredSelector} from 'reselect'

import Card from 'broker/views/components/Card'
import RawCardSection from 'broker/views/components/CardSection'
import AgentList from 'broker/views/components/Deprecating/AgentList'
import AgentListSearch from 'broker/views/components/Deprecating/AgentListSearch'

import { selectAccountLoading } from 'broker/selectors/account'


const CardSection = connect(createStructuredSelector({
  loading: selectAccountLoading
}))(RawCardSection)


class BrokerTopPerformingAgentsCard extends Component {
  render() {
    return <Card>
      <CardSection
        title="Agents"
        renderActionButton={() => <AgentListSearch/>}
      >
        <AgentList/>
      </CardSection>
    </Card>
  }
}

export default BrokerTopPerformingAgentsCard
